import { personalizedCardArtUrl } from "./endpoints.js";
const personalizedCardArtCacheKey = ({
  accountId,
  accountIdType
}) => [personalizedCardArtUrl, { accountId, accountIdType }];
export {
  personalizedCardArtCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
